import React from 'react';
import { cmsLinkProps } from './propTypes';
import { NavLink } from 'react-router-dom';
import isURL from 'validator/lib/isURL';

import ExternalLink from './components/ExternalLink';

const CMSLink = ({url, target, onClick = null, isAccountApp = false, useExternalLinkIcon = false, className = null, children, ...props}) => {

    const activeClass = () => {
        const menu = props.menu !== undefined ? props.menu : [];
        const topLevelNav = menu.find(navLink => navLink.menuText === children);
        const activeTopLevelNav = topLevelNav !== undefined &&
                topLevelNav.children.find(link => link.href === location.pathname
                    ?   topLevelNav.menuText
                    :   undefined
                );

        return activeTopLevelNav !== undefined ? 'active' : '';
    };

    if (!url) {

        return (
            <span className={`${className} ${activeClass()}`}>
                {children}
            </span>
        )

        // We force target="_blank" for all external URLs.
        // Until there is a validator in CMS to disable the target select when the destination URL is an external URL
        // This is the best we can do to prevent CMS users from using the incorrect target.
    } else if (isURL(url) || target === '_blank') {

        let fixedHref = url;

        // If the protocol was left off we assume that http is the proper protocol, It's the best we can do
        if (!isURL(url, {require_protocol: true})) {
            fixedHref = `http://${fixedHref}`;
        }

        return (
            <ExternalLink
                href={fixedHref}
                onClick={onClick}
                className={className}
                activeClass={activeClass()}
                useIcon={useExternalLinkIcon}>
                { children }
            </ExternalLink>
        );

    } else if (isAccountApp) {
        return (
            <ExternalLink
                href={url}
                target='_self'
                onClick={onClick}
                className={className}
                activeClass={activeClass()}>
                { children }
            </ExternalLink>
        )
    } else {
        return (
            <NavLink
                to={url}
                onClick={onClick}
                className={className}
            >
                { children }
            </NavLink>
        )
    }

};

CMSLink.propTypes = cmsLinkProps;

export default CMSLink;


